import React from "react";
import "./view.css";

const mapWith = () => {
  const width = document.documentElement.clientWidth;
  if (width < 400) return width;
  if (width > 1100) return 990;
  return Math.round((width * 9) / 10);
};

const MapsView = () => (
  <div className="mapouter">
    <div className="gmap_canvas">
      <iframe
        title="Hitta hit"
        width={mapWith()}
        height="500"
        id="gmap_canvas"
        src="https://maps.google.com/maps?q=%20Tegelg%C3%A5rdsgatan%203%2021133%20Malm%C3%B6%2C%20Sweden&t=&z=17&ie=UTF8&iwloc=&output=embed"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
      />
    </div>
    <style>{`.gmap_canvas { width:${mapWith()}px }`}</style>
  </div>
);

export default MapsView;
